import React, { useMemo } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import { useAppDispatch, useAppSelector } from "application/store";
import { GlobalSliceAction } from "application/store/global/slice";
import { globalSelector } from "application/store/global/selectors";

import { commonColors } from "application/theme";
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from "./styles";

function CustomSnackbar() {
  const dispatch = useAppDispatch();
  const { open, message, severity } = useAppSelector(globalSelector).snackBar;

  const Icon = useMemo(() => {
    switch (severity) {
      case "success":
        return SuccessIcon;
      case "error":
        return ErrorIcon;
      case "info":
        return InfoIcon;
      case "warning":
        return WarningIcon;
      default:
        return ErrorIcon;
    }
  }, [severity]);

  const onClose = () => {
    dispatch(GlobalSliceAction.closeSnackBar());
  };

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        icon={<Icon />}
        sx={{
          // font
          fontSize: 16,
          fontWeight: 400,
          fontFamily: "Unica77",
          color: commonColors.grey900,
          // rest
          width: "100%",
          borderRadius: "12px",
          background: commonColors.white,
          boxShadow: "0 4px 10px 0 rgba(26, 40, 104, 0.10)",
          // MUI
          "& .MuiAlert-icon": {
            marginRight: "8px",
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default CustomSnackbar;
